var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-left"},[_c('button',{staticClass:"banner-left__toggle",on:{"click":function($event){return _vm.toggle()}}},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }